// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__FbGmR","content":"Page_content__2BxjJ","scrollingDisabled":"Page_scrollingDisabled__38rLG"};